app.directive('associatedDocuments', ['portalHelper', 'authHelper', 'storageService', '$injector',
  function (portalHelper, authHelper, storageService, $injector) {
    return {
      scope: {
        documents: '='
      },
      templateUrl: portalHelper.getUrlRev('html_templates/directives/associated_documents.6768db85.html'),
      controller: function ($scope) {
        $scope.isLocalStorageSupported = storageService.isLocalStorageSupported;
        $scope.getUrl = portalHelper.getUrl;

        // RPR-6752: live Mux processing status (percent + ETA) for each attached
        // video, keyed by doc id in a side map so the two-way-bound `documents`
        // objects are never mutated. A ready/errored video costs a single status
        // GET (the poller auto-stops on terminal); only in-flight ones keep polling.
        $scope.videoStatus = {};
        let pollers = [];

        function stopPollers() {
          pollers.forEach(function (poller) { poller.stop(); });
          pollers = [];
        }

        function applyStatus(entry, data) {
          const status = data?.status;
          entry.isProcessing = status === 'processing' || status === 'uploading';
          // RPR-6752: the row poller reports 'timed_out' at the stall / hard
          // ceiling. Surface that rather than silently dropping the pill (parity
          // with the Document Manager's "Processing (taking longer)" badge).
          //
          // RPR-6923: repeated poll FAILURES now arrive as 'timed_out' plus
          // `poll_failed`, so the flag -- paired with 'timed_out' -- tells an unreadable
          // status apart from a failed transcode.
          //
          // Only ONE direction was broken here, contrary to an earlier version of this
          // comment: keying "status unavailable" on 'errored' meant a video Mux genuinely
          // failed to transcode was described as merely unreadable. The other direction
          // was already right on THIS surface -- a poll failure arrived as 'errored' and
          // rendered "Status unavailable", which is what it is. Describing a healthy
          // video as failed was rpr_video_player's and portal_helper's problem, not this
          // file's. `entry.failed` is the new part, and it is what the Errored badge
          // below reads.
          entry.takingLonger = status === 'timed_out' && !data?.poll_failed;
          entry.statusUnavailable = status === 'timed_out' && data?.poll_failed === true;
          entry.failed = status === 'errored';
          entry.percent = data?.progress?.percent != null ? data.progress.percent : null;
          entry.etaLabel = portalHelper.formatVideoEta(data?.estimated_seconds_remaining);
        }

        function startVideoPoller(doc, pollerFactory) {
          const entry = {
            isProcessing: false, takingLonger: false, statusUnavailable: false, failed: false,
            percent: null, etaLabel: null
          };
          $scope.videoStatus[doc.id] = entry;
          const poller = pollerFactory.create({
            documentId: doc.id,
            onUpdate: function (data) {
              applyStatus(entry, data);
              $scope.$applyAsync();
            }
          });
          poller.start();
          pollers.push(poller);
        }

        function startVideoStatusPolling(documents) {
          stopPollers();
          $scope.videoStatus = {};
          // The status endpoint is authoring-only (/api/authoring/video/:id/status/).
          // This directive also renders on payer-facing pages, whose bundle
          // (payer/index.html) doesn't even load videoStatusPollerFactory. Skip for
          // payer sessions AND when the poller isn't registered in the current app
          // bundle (resolved lazily via $injector so a missing provider can't break
          // directive construction) -- either way, payer views are unchanged.
          if (authHelper.isUserPayer() || !$injector.has('videoStatusPollerFactory')) { return; }
          const pollerFactory = $injector.get('videoStatusPollerFactory');
          (documents || []).forEach(function (doc) {
            if (doc?.media_type === 'video') { startVideoPoller(doc, pollerFactory); }
          });
        }

        $scope.$watch('documents', function () {
          portalHelper.escapeDocumentNames($scope.documents);
          startVideoStatusPolling($scope.documents);
        });

        $scope.$on('$destroy', stopPollers);
      }
    };
  }]
);
